import { Grid } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import TrainingModule from "../../models/trainingModule";
import Gradient1 from "../../styles/illustrations/gradients/gradient_1.png";
import { Typography } from "../ui/Typography/Typography";
import { IconTypes } from "../ui/icons";
import { Icon } from "../ui/icons/Icon";
import "./TrainingModuleInfo.scss";

interface TrainingModuleInfoProps {
  trainingModule: TrainingModule;
}
export const TrainingModuleInfo = ({
  trainingModule,
}: TrainingModuleInfoProps) => {
  const { t } = useTranslation("trainingPage");

  return (
    <div className="TrainingModuleInfo">
      <div className="TrainingModuleInfo__header">
        <img src={Gradient1} alt="" />
        <Typography desktop="body1" weight="bold">
          {trainingModule.title}
        </Typography>
      </div>
      <Typography desktop="body2" color="secondary">
        {trainingModule.description || ""}
      </Typography>
      <Grid container>
        <Grid item sm={6} className="TrainingModuleInfo__info__item">
          <Icon type={IconTypes.Audience} color="secondary" />
          <Typography desktop="body2" color="secondary">
            {t(`modules.audience.${trainingModule.audience.toLowerCase()}`)}
          </Typography>
        </Grid>
        <Grid item sm={6} className="TrainingModuleInfo__info__item">
          <Icon type={IconTypes.Touchpoint} color="secondary" />
          <Typography desktop="body2" color="secondary">
            {t(`modules.touchpoints.info`, {
              count: trainingModule.touchPoints.length,
              duration: trainingModule.duration,
            })}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};
